import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDietitianStoreAction, setProfileStoreAction } from "Root/profile/redux/actionCreators/makeActionCreator";
import { LoadRegisteredDietitianThunk } from "Root/profile/redux/thunkCreators/dietitian/registeredDietitian";
import { fetchProfileDataThunk } from "Root/profile/redux/thunkCreators/myProfile/profileThunk";
import NavBar from "../Navigation/NavBar";
import ExploreTeam from "./ExploreTeam";
import RdChatPage from "./RdChatPage";
import RDFAQ from "./RDFAQ";
import RdGetInTouch from "./RdGetInTouch";
import RDHub from "./RdHub";
import YourRd from "./YourRD";
const RDPageV2 = () => {
    const dispatch = useDispatch();
    const reduxStoreIsEmpty = useSelector((state) => state.checkStore.dietitian);
    const profileReduxStoreIsEmpty = useSelector((state) => state.checkStore.profile);
    const user = useSelector((state) => state.user);
    const [isChatPage, setIsChatPage] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
        if (reduxStoreIsEmpty) {
            dispatch(LoadRegisteredDietitianThunk());
            dispatch(setDietitianStoreAction(false));
        }
        if (profileReduxStoreIsEmpty) {
            dispatch(fetchProfileDataThunk());
            dispatch(setProfileStoreAction(false));
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(NavBar, { userName: user.full_name, showTop: true, userLoggedIn: true, hasSubscription: user.has_subscription, bannerData: user.banner_data }), isChatPage ? (_jsx(RdChatPage, { goBack: () => setIsChatPage(false) })) : (_jsxs(_Fragment, { children: [_jsx(YourRd, {}), _jsx(RDHub, { openChat: () => setIsChatPage(true) }), _jsx(RdGetInTouch, { openChat: () => setIsChatPage(true) }), _jsx(ExploreTeam, {}), _jsx(RDFAQ, {})] }))] }));
};
export default RDPageV2;
